import { uniqueId } from 'lodash'
import React from 'react'
import { RiDeleteBin2Fill } from 'react-icons/ri'
import { Field } from 'redux-form'
import { required } from 'redux-form-validators'
import InputField from '../../../../../../../../helpers/Fields/InputField'
import './AnswerType7.scss'
import { Popconfirm } from 'antd';


function AnswerType7({answers, formatMessage, rootChange}) {
  return (
    <div className='AnswerType7'>
      {answers.map((_i, index) => 
        <div key={_i._id} className='item'>
          <div className='field'>
            <Field
              name={`answers[${index}].question`}
              placeholder={formatMessage('Question')}
              component={InputField}
              validate={[required()]}
            />
          </div>
          <div className='field'>
            <Field
              name={`answers[${index}].answer`}
              placeholder={formatMessage('Answer')}
              component={InputField}
              validate={[required()]}
            />
          </div>
          {index > 0 && <Popconfirm
            title={formatMessage('deleteItemAnswerType7')}
            onConfirm={() => {
              rootChange('answers', answers.filter((_i, ind) => ind != index))
            }}
            // onCancel={cancel}
            okText={formatMessage('deleteItemAnswerType7Yes')}
            cancelText={formatMessage('deleteItemAnswerType7No')}
          >
            <div className='icon'>
              <RiDeleteBin2Fill size="20" />
            </div>
          </Popconfirm>}
          {index == 0 && <div style={{width: 50}} />}
        </div>
      )}
      <div className='itemCreate' onClick={() => {
        rootChange('answers',[
          ...answers,
          {
            _id: uniqueId('variant-') + Date.now(),
            question: '',
            answer: ''
          }
        ])
      }}>{formatMessage('createItemType7')}</div>
    </div>
  )
}

export default AnswerType7


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/components/AnswerType7/AnswerType7.jsx